const SET_ERROR = 'SET_ERROR';
const REMOVE_ERROR = 'REMOVE_ERROR';

export default {
	SET_ERROR,
	REMOVE_ERROR,
};
